export const isMac =
  typeof navigator !== "undefined" &&
  /Mac|iPod|iPhone|iPad/.test(navigator.platform);

/**
 * Whether the event carries the platform's primary shortcut modifier: cmd on
 * macOS, ctrl everywhere else.
 *
 * Not `metaKey || ctrlKey`. Off macOS `metaKey` is the Windows/Super key, which
 * the window manager takes before the page sees it; on macOS a plain ctrl-click
 * is a right-click, so accepting both fires the shortcut alongside a context
 * menu.
 */
export function hasPlatformModifier(event: {
  metaKey: boolean;
  ctrlKey: boolean;
}): boolean {
  return isMac ? event.metaKey : event.ctrlKey;
}
